import React from 'react';

export default function Card({ children, style, padding = 32 }) {
  return (
    <div style={{
      background: '#fff',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-md)',
      border: '1px solid var(--color-border)',
      padding,
      ...style,
    }}>
      {children}
    </div>
  );
}
